import useAxios, { configure } from 'axios-hooks';
import LRU from 'lru-cache';
import Axios from 'axios';

import { useMemo, useEffect } from 'react';
import { useUser } from './auth';
import { getMergedConfig, handleResponseErrors } from './apiHelpers';
import { getStoredTenant } from './storage/UnitySessionStorage';

const axios = Axios.create({
  baseURL: process.env.UNITY_DEMO_API_BASE,
});

const cache = new LRU({ max: 10 });

configure({ axios, cache });

export const useAxiosGetQuery = (url, params, isManual) => {
  const [{ data, loading, error }, refetch] = useAxios(
    { url, params },
    { manual: isManual }
  );
  return [{ data, loading, error }, refetch];
};

export const useAxiosGet = (baseURL, url, config = {}, isManual, useCache) => {
  const user = useUser();

  if (!user?.accessToken) {
    isManual = true;
  }

  if (config?.headers && !config?.headers?.currentTenantId) {
    config.headers['currentTenantId'] = getStoredTenant();
  }

  const mergedConfig = useMemo(() => {
    return getMergedConfig(user?.accessToken, config);
  }, [config, user]);

  const fullURL = { url: `${baseURL}/${url}` };
  const [{ data, loading, error }, refetch] = useAxios(
    { ...fullURL, ...mergedConfig },
    { manual: isManual, useCache: useCache || true }
  );

  useEffect(() => {
    handleResponseErrors(error);
  }, [error]);

  return [{ data, loading, error }, refetch];
};
